var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShowService)?_c('div',{staticClass:"row ml-0 mb-4"},[_c('SectionTitle',{attrs:{"content":"Estatus del Servicio","has-line":true}}),_vm._l((_vm.services),function(service,index){return _c('row',{key:index,attrs:{"item":service}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }